export const smachWizardPeriod = 89;

export function computeCHWScan(data: anychart.data.Table, mode:string = "HIGH", symbol:string) {
    var longCtx: anychart.math.sma.Context = anychart.math.sma.initContext(smachWizardPeriod);
   //console.log(mode)
    var mapping = data.mapAs();
    mapping.addField("dt", 0);

    mapping.addField("close", 4);

    if(mode=="HIGH")
    {
         mapping.addField("high", 2);
    }

    if(mode=="LOW")
    {
         mapping.addField("low", 3);
    }
   
    var sel = mapping.createSelectable().selectAll()
    var iterlong = sel.getIterator();
    
    var longValues: ICHWLongResult[] = [];
   
    while (iterlong.advance()) {
        var dt = iterlong.get("dt");
        var close = iterlong.get("close");

        if(mode=="HIGH")
        {
          var c = iterlong.get("high");
        }

        if(mode=="LOW")
        {
          var c = iterlong.get("low");
        }

        var long = anychart.math.sma.calculate(longCtx, c);
        longValues.push({
            date: dt,
            value: long,
            dataVal: close
        });
    }


    let inRule = 0;
    let limit = longValues.length>=100?100:longValues.length;
    for(let i = 2; i<limit; i++)
    {
    //    console.log(longValues[longValues.length-i])
    //  //  console.log(longValues[longValues.length-i])

    //  if(longValues[longValues.length-i]==undefined)
    //  {
    //      debugger;
    //  }
        if(mode=="HIGH")
        {

            if(longValues[longValues.length-i].dataVal<=longValues[longValues.length-i].value)
            {
            //    console.log("longValues")
            //    console.log([symbol,longValues]);

            if(symbol=="AUD/CAD")
            {
                console.log("longValues")
                console.log([symbol,longValues]);
            }


               return inRule;
            }


            if(longValues[longValues.length-i].dataVal>longValues[longValues.length-i].value)
            {
                inRule++;
            }

        }

        if(mode=="LOW")
        {
            if(longValues[longValues.length-i].dataVal>=longValues[longValues.length-i].value)
            {
           //     console.log("longValues")
          //      console.log([symbol,longValues]);
                if(symbol=="AUD/CAD")
                {
                    console.log("longValues")
                    console.log([symbol,longValues]);
                }
                return inRule;
            }
            if(longValues[longValues.length-i].dataVal<longValues[longValues.length-i].value)
            {
                inRule++;
            }
        }
    }

    if(symbol=="AUD/CAD")
    {
        console.log("longValues")
        console.log([symbol,longValues]);
    }
   

    return inRule;
}

export interface ICHWLongResult {
    date: number;
    value: number;
    dataVal:number;
}